import { Stack } from "@/core/components/ui/stack";
import {
  DocumentListFilters,
  ListTableCard,
  useApBusinessTimeZone,
} from "@/accounts-payable/common";
import { apToday, documentListEmptyMessage } from "@/accounts-payable/utils";
import {
  vendorCol,
  statusCol,
  invoiceNumberCol,
  jobCol,
  dateCol,
  addedCol,
  reviewCol,
  totalCol,
} from "./cols";
import { INVOICE_FILTERS, useInvoicesTab } from "./use-invoices-tab";

const columns = [
  vendorCol,
  statusCol,
  invoiceNumberCol,
  jobCol,
  dateCol,
  addedCol,
  reviewCol,
  totalCol,
];

export const ApInvoicesTab = ({
  businessId,
  selectedId = null,
  onSelect,
}: {
  businessId: string | null;
  selectedId?: string | null;
  onSelect: (id: string) => void;
}) => {
  const {
    query,
    viewportRef,
    onViewportScroll,
    awaitingPosition,
    restoring,
    filter,
    setFilter,
    search,
    setSearch,
    dayField,
    setDayField,
    dayRange,
    setDayRange,
    debouncedSearch,
  } = useInvoicesTab(businessId);

  const today = apToday(useApBusinessTimeZone());

  return (
    <Stack gap="none" fullWidth className="h-full min-h-0">
      <DocumentListFilters
        kind="invoice"
        statusFilters={INVOICE_FILTERS}
        status={filter}
        onStatusChange={setFilter}
        dayField={dayField}
        onDayFieldChange={setDayField}
        dayRange={dayRange}
        onDayRangeChange={setDayRange}
        search={search}
        onSearchChange={setSearch}
        searchPlaceholder="Search vendor or invoice #"
      />

      <ListTableCard
        query={query}
        viewportRef={viewportRef}
        onViewportScroll={onViewportScroll}
        awaitingPosition={awaitingPosition}
        restoring={restoring}
        columns={columns}
        selectedId={selectedId}
        onSelect={onSelect}
        className="mt-0"
        empty={documentListEmptyMessage("invoice", {
          range: dayRange,
          field: dayField,
          filtered: filter !== "all" || debouncedSearch.trim() !== "",
          today,
        })}
        error={{
          title: "Couldn’t load invoices",
          body: "Please try again in a moment.",
        }}
      />
    </Stack>
  );
};
